import { render, staticRenderFns } from "./Rightship.vue?vue&type=template&id=5a063a2a&scoped=true&"
import script from "./Rightship.vue?vue&type=script&lang=js&"
export * from "./Rightship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a063a2a",
  null
  
)

export default component.exports